// Ensure webpack processes the main scss file.
import "../scss/main.scss";

// Register plugins
gsap.registerPlugin(ScrollTrigger);

// Import core scripts
import "./main/core/accessibility.js";

// Import our layout scripts
//import './main/layout/header.js';
//import './main/layout/footer.js';

// Import UI scripts
// import './main/ui/buttons.js';
// import './main/ui/links.js';

// Import animation scripts
import "./main/animations/fade-in-up.js";
// import './main/animations/scroll-highlighter.js';
// import './main/animations/case-study-titles.js';

// Current Link

document
  .querySelectorAll('a[href="' + document.URL + '"]')
  .forEach((link) => (link.className += " current-link"));

// document ready

// document.addEventListener("DOMContentLoaded", function () {
// console.log(
//   "%cDesigned & Built By",
//   "font-family: Arial, sans-serif;font-size: 12px;font-weight: 300;text-transform: uppercase;line-height: 2;vertical-align: text-bottom;padding: 30px 186px 0px 30px;"
// ),
//   console.log(
//     "%cTwirling Umbrellas",
//     "font-family: Arial, serif;font-size: 40px;font-weight: 800;padding: 0px 0 2px 30px;"
//   ),
//   console.log(
//     "%cwww.twirlingumbrellas.com",
//     "font-family: Arial, sans-serif;font-size: 10px;font-weight: 200;text-transform: uppercase;line-height: 1;text-decoration: none;padding: 10px 10px 40px 30px;color: #FFF;"
//   );

// console.log(

//   "font-family: Arial, sans-serif;font-size: 10px;font-weight: 300;text-transform: uppercase;line-height: 2;vertical-align: text-bottom;padding: 30px 186px 0px 30px;"
// ),
console.log(
  "%cDesigned and developed by%c\nTwirling Umbrellas\n%cKiller Digital. Friendly Humans. ™",
  "font-family: Arial, sans-serif;font-size: 10px;font-weight: 300;text-transform: uppercase;line-height: 1;padding:30px 0px 10px 30px;",

  "font-family: Arial, serif;font-size: 40px;font-weight: 800;padding: 0px 0px 5px 30px;",

  "font-family: Arial, sans-serif;font-size: 12px;font-weight: 200;line-height: 1;text-decoration: none;padding: 0px 0px 30px 6px;color: #FFF;"
),
  console.log(
    "%cwww.twirlingumbrellas.com",
    "font-family: Arial, sans-serif;font-size: 10px;font-weight: 200;text-transform: uppercase;line-height: 1;text-decoration: none;padding: 10px 10px 40px 30px;color: #FFF;"
  );

// });
